<template>
  <div>
    <div class="admin">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main pb-5">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-5 font-weight-black">Agregar gasto</h1>

                  <v-btn color="grey" outlined dark to="/admin/gastos">
                    <v-icon left>keyboard_backspace</v-icon>Regresar a gastos
                  </v-btn>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <v-textarea
                  outlined
                  v-model="descripcion"
                  auto-grow
                  label="Descripción del gasto"
                ></v-textarea>

                <div class="row">
                  <div class="col" style="padding-left: 0">
                    <v-text-field
                      label="Monto"
                      placeholder="$"
                      outlined
                      v-model="monto"
                    />
                  </div>

                  <div class="col" style="padding-right: 0">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="fecha"
                      persistent
                      full-width
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="fecha"
                          label="Fecha"
                          prepend-icon="event"
                          readonly
                          outlined
                          background-color="#ffffff"
                          v-on="on"
                        ></v-text-field>
                      </template>

                      <v-date-picker v-model="fecha">
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(fecha)"
                          >OK</v-btn
                        >
                        <v-btn text color="primary" @click="modal = false"
                          >Cancelar</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </div>
                </div>

                <v-btn large color="primary" @click="validar()"
                  >Agregar gasto</v-btn
                >
              </div>
            </div>
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
const axios = require("axios");
import router from "@/router";
export default {
  components: { DatePicker },
  data() {
    return {
      modal: "",
      fecha: "",
      monto: "",
      descripcion: "",
      loader: false,

      // custom lang
      lang: {
        days: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        months: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        pickers: [
          "siguiente 7 días",
          "siguiente 30 días",
          "7 días anteriores",
          "30 días anteriores",
        ],
        placeholder: {
          date: "Selecciona el día",
          dateRange: "Selecciona el rango",
        },
      },
      // custom range shortcuts
      shortcuts: [
        {
          text: "Hoy",
          onClick: () => {
            this.time3 = [new Date(), new Date()];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
    };
  },
  methods: {
    validar() {
      if (this.descripcion == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Ingresa la descripción del gasto",
          showConfirmButton: true,
        });
      } else if (this.monto == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Ingresa el monto del gasto",
          showConfirmButton: true,
        });
      } else if (this.fecha == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Selecciona la fecha del gasto",
          showConfirmButton: true,
        });
      } else {
        //Los datos requeridos se ingresaron
        this.guardar();
      }
    },

    guardar() {
      this.loader = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=saveGasto" +
            "&descripcion=" +
            this.descripcion +
            "&monto=" +
            this.monto +
            "&fecha=" +
            this.fecha
        )
        .then((response) => {
          this.loader = false;

          //Mostramos notificación
          this.$swal({
            type: "success",
            title: "El gasto se creó exitosamente",
            showConfirmButton: true,
          });

          //Reseteamos los valores
          this.descripcion = "";
          this.fecha = "";
          this.monto = "";
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {},
};
</script>
